export default {
  formValidation: {
    emptyField: 'Il campo non può essere vuoto',
    requiredField: 'Il campo è obbligatorio',
    passwordToShort: 'La password deve essere di 8 caratteri',
    emailNotValid: 'Il campo deve contenere un indirizzo e-mail valido',
    emailReserved: "L'indirizzo e-mail è già occupato",
    rateEmpty: 'Tutti i campi devono essere compilati',
    serverUnknownError: 'Errore di comunicazione del server',
    invalidCharacters: 'Il campo contiene caratteri non validi',
    phoneNotValid: 'Il numero di telefono non è corretto',
    checkBoxBelow: 'Selezionare la casella sottostante per inviare un messaggio',
  },
  password: {
    show: 'mostrare',
    hide: 'nascondere',
  },
  howItWorks: {
    showButton: 'Mostra di più',
    hideButton: 'Mostra meno',
  },
}
